(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["product-template"]) return;
  try {
    
// Move Bought Together

    applyWhenElementExists('.cbb-frequently-bought-container', function(){
        let bought_el = $('.cbb-frequently-bought-container');
        if( window.innerWidth > 768 ) {
           bought_el.appendTo('.product_section .nine.columns');
        }else{
		   bought_el.prependTo('.product_section .sixteen.columns');
		}
        //bought_el.remove(); 
    },50); 
      

      function applyWhenElementExists(selector, myFunction, intervalTime) {
         var interval = setInterval(function() {
           if (jQuery(selector).length > 0) {
              myFunction();
              clearInterval(interval);
           }
         }, intervalTime);
       }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-menu"]) return;
  try {
    

let hash = window.location.hash;

const loader = $('.lds-dual-ring');
if (hash) {
	loadJSONcollection(hash.substr(1)); 
}else{
	loadJSONcollection('best-selling-products');
}


$('.collection-item').click(function(e){
	e.preventDefault();
	let handle = $(this).data('handle');
	$('#header .open').click();
	loadJSONcollection(handle); 
});

function loadJSONcollection(collection,state=true) {
let urlPath = "/collections/"+collection;
	$('#products').html( loader );
	$.ajax({
		//url:	"/collections/"+collection+"/products.json?limit=900",
		url:	urlPath,
		type:	'GET'
	})
	.done(function(data) { 
		if ( state ) { window.history.pushState({"collection":collection},"", '/#'+collection); }
		let products_html = $('.twelve.columns.medium-down--one-whole',$(data)).html();
		$('#products').html( products_html );
		/* var product = data.products;
		//var product = $.parseJSON(data);
		$(product).each(function(index){
			//console.log(this.title); 
		}); */
	})
	.fail(function(data) {})
	.always(function(data) {});
}

window.onpopstate = function(e){
    if(e.state){
        loadJSONcollection(e.state.collection,false);
    }
};


  } catch(e) { console.error(e); }
})();

})();
